var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropzone',{ref:"dropzone",attrs:{"options":_vm.dropzoneOptions,"id":_vm._uid+'vwdropzone'},on:{"vdropzone-success":_vm.fileUploaded,"vdropzone-file-added":_vm.fileAdded}})
}
var staticRenderFns = []

export { render, staticRenderFns }